import React from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import './NavBar.css';
import svg from './svg.svg';

const NavBar = () => {
    return (
        <section className="container">
            <Navbar collapseOnSelect expand="lg" bg="transparent" variant="dark">
                <Navbar.Brand>
                    <img className="nav-img" src={svg} alt="" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="m-auto">
                        <Nav.Link className="nav-items" href="#home">Home</Nav.Link>
                        <Nav.Link className="nav-items" href="#about-me">About Me</Nav.Link>
                        <Nav.Link className="nav-items" href="#my-work">My Work</Nav.Link>
                        <Nav.Link className="nav-items" href="#blogs">Blogs</Nav.Link>
                        <Nav.Link className="nav-items" href="#my-resume">Resume</Nav.Link>
                        <Nav.Link className="nav-items" href="#contact">Contact</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </section>
    );
};

export default NavBar;